function cartView(){
  
}
let scrollOffset = 200;
if(window.innerWidth < 768)
   scrollOffset = 120;
$('.header-cart-btn a').trigger("click");
window.cartRefresh = function(){
  fetch(window.Shopify.routes.root + "?sections=cart-drawer")
  .then(res => {return res.json()})
  .then((data) => { 
    $('#sidebar-cart .Drawer__Content .Drawer__Main').html($(data["cart-drawer"]).find('.Drawer__Content .Drawer__Main').html()); 
  })
  jQuery.getJSON('/cart.js', function(cart) {
    let item_count = 0; 
    for(item of cart.items){ 
      if(item.properties._type && item.properties._type != "child")
        item_count++;
    } 
       setTimeout(function() {  
    
     
    $("#FinalTotalVal").html("Rs. "+((cart.total_price)/100).toFixed(2))    
    },500)
}).then((data) => { 
    console.log(data,"clicked"); 
  })
} 

$(".bvc-accordian h3.title").on("click",function(){
  $(this).toggleClass("active");
  $(this).next().toggleClass("active");
  $(this).next().toggleClass("hide");
})

$(".add-bvc-box-product").on("click",function(){
  let dataIndex = $(this).data("buttonindex"); 
  let accordianSectionId = $(".selected-box-items .item-header[data-count="+dataIndex+"]").parent().data("selectedcollection");
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .title").removeClass("active");
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .accordian-pannel").removeClass("active").addClass("hide");
  $(".selected-box-items .item-header[data-count="+dataIndex+"] .image img").attr("src",$(this).data("image"));  
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .add-bvc-box-product").val("Add To Box").removeClass("added").css({"opacity":"1","pointer-events":"all"});
  $(this).val("Added To Box").css({"opacity":"0.5","pointer-events":"none"}).addClass("added");
   $(".selected-box-items .item-header[data-count="+dataIndex+"]").parent().addClass("active");
  if(boxSize == $(".add-bvc-box-product.added").length){
    addBoxtoCart();
  }

  if($(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"']").next().length > 0){
  let nextAccordian = $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"']").next();
   window.scrollTo({top:(nextAccordian.offset().top - scrollOffset),behavior: 'smooth'});
  nextAccordian.find(".title").addClass("active");
  nextAccordian.find(".accordian-pannel").addClass("active");
  }
})

$(".cancle-item").on("click",function(){ 
  let accordianSectionId = $(this).data("cancleitmecollectionid");  
  let nextAccordian = $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"']");
  $(".selected-box-items .selected-item[data-selectedcollection="+accordianSectionId+"] .image img").attr("src","");
  $(".selected-box-items .selected-item[data-selectedcollection="+accordianSectionId+"]").removeClass("active");
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .add-bvc-box-product").val("Add To Box").removeClass("added").css({"opacity":"1","pointer-events":"all"});
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .title").addClass("active");
  $(".bvc-accordian[data-accordianmainid='"+accordianSectionId+"'] .accordian-pannel").addClass("active").removeClass("hide");
  window.scrollTo({top:(nextAccordian.offset().top - scrollOffset),behavior: 'smooth'});
})

function addBoxtoCart(){
  $(".add-bvc-box-product.added").each(function(){
     let dataVariantId = Number($(this).prev().val());
       buildBoxItems.items.push({
        id:dataVariantId,
        quantity:1,
        properties:{
          _type:"child", 
          _boxnumber:boxNumber
        }
    })
  })
  window.scrollTo({top:0,behavior: 'smooth'});
 // $(".selected-item.selected-button .item-title").text("ADDING TO");
  console.log(buildBoxItems);
  var i = 0;
 // for( item in buildBoxItems){ 
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(buildBoxItems));
    $("#x-processing-overlay").removeClass("hidden");
  setTimeout(function(){  
        // subtotalUpdate();     
           window.cartRefresh();
            resetBoxPage();
            $("#x-processing-overlay").addClass("_build_another");
            $("#x-processing-overlay .x-loader").remove();
            $("#x-processing-overlay .x-loading-text").text("Your Box is Ready!").append("<a href='#' onclick='location.reload()'><input type='button' class='btn cv--atc' value='Build Another Box'></a>");
  },2000); 
           Shopify.getCart(function(cart) {  
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              setTimeout(function(){jQuery('.header-cart-btn').find('a')[0].click(); }, 2100); 
             }); 
}
function resetBoxPage(){
   $(".selected-box-items .selected-item:not(.selected-button) .image img").attr("src","");
   $(".selected-box-items .selected-item").removeClass("active");
   $(".bvc-accordian .add-bvc-box-product").val("Add To Box").removeClass("added").css({"opacity":"1","pointer-events":"all"});
   $(".bvc-accordian .title").removeClass("active");
   $(".bvc-accordian .title._first").addClass("active");
  $(".bvc-accordian .accordian-pannel").removeClass("active").removeClass("hide");;
   $(".bvc-accordian .accordian-pannel._first").addClass("active")
}

function removeBox(boxid){
  let boxIds = boxid.split(",");
  boxIds.pop();
  let removeBoxItems = {};
  removeBoxItems.updates = {}
  for (let id of boxIds){ 
  removeBoxItems.updates[id] = 0; 
   }  
  const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(removeBoxItems));
  setTimeout(function(){
 // subtotalUpdate();
   window.cartRefresh();
  },300)  
}

$("body").on("click","._minus,._plus",function(){
    if($(this).hasClass("_plus")){
       if($(this).prev().val() >= Number($(this).attr("data-qty"))){
         return;
        }
       $(this).prev().val(+$(this).prev().val() + 1);    
       var quantity = $(this).prev().val();
    }else{
      $(this).next().val(+$(this).next().val() - 1);    
       var quantity = $(this).next().val();
    }
   let boxIds = $(this).data("keys").split(",");
    boxIds.pop();
   let updateBoxItems = {};
    updateBoxItems.updates = {}
    for (let id of boxIds){ 
    updateBoxItems.updates[id] = Number(quantity); 
     }  
   const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(updateBoxItems));
   setTimeout(function(){
 // subtotalUpdate();
   window.cartRefresh();
       },500)  
});